// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.re-design-campaign-selection-row {
  padding: 20px 73px 20px 55px !important;
  background: var(--Icon-Default-Default, #ffffff);
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.re-design-campaign-selection-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.review-products-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}
.review-products-count-grey {
  background: #e5e7eb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: #99a1af;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}
.review-each-asset-conatiner {
  display: flex;
  align-items: center;
  gap: 5px !important;
  width: 100% !important;
  border-radius: 16px;
  border-width: 1px;
  border-top: 1px solid #f3f4f6;
  height: 60px;
  border: 1px solid #edf0f4;
  border-radius: 16px;
  background: #fff !important;
  padding: 20px;
}
.negotiate-terms-container {
  width: 93%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
.negotiate-terms-chat-container {
  width: 5%;
  height: 100%;
  opacity: 1;
  border-radius: 16px;
  border-width: 1px;
  background: var(--Icon-Default-Default, #ffffff);
  border: 1px solid #f3f4f6;
}
.negotiate-terms-table-container {
  width: 70%;
}
.negotiate-terms-chat {
  width: 25%;
}
.assets-table-wrapper {
  width: 100%;
  overflow: hidden;
  border: 1px solid #edf0f4;
  border-radius: 16px;
  background: #fff;
}

.negotiate-assets-table {
  width: 100%;
}

.negotiate-assets-table .ant-table {
  background: transparent;
}

.negotiate-assets-table .ant-table-container {
  border: none !important;
}

.negotiate-assets-table .ant-table-thead > tr > th {
  height: 38px;
  padding: 0 20px;
  border-bottom-width: 1px;
  background: #f9fafb !important;
  border-bottom: 1px solid #f3f4f6;
  color: #99a1af !important;
  font-family: Roboto !important;
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.negotiate-assets-table .ant-table-thead > tr > th::before {
  display: none !important;
}

.negotiate-assets-table .ant-table-tbody > tr > td {
  height: 60px;
  padding: 10px 20px;

  background: #fff;
  border-bottom: 1px solid #f0f2f5 !important;

  color: #526174;
  font-size: 12px;
}

.negotiate-assets-table .ant-table-tbody > tr:last-child > td {
  border-bottom: none !important;
}

.negotiate-assets-table .ant-table-tbody > tr:hover > td {
  background: #fff !important;
}
.asset-cell {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.asset-meta {
  display: flex;
  align-items: center;
  gap: 5px;

  color: #9aa5b5;
  font-size: 10px;
}

.slot-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  padding: 0;
  border: 1px solid #d9e0ea;
  border-radius: 4px;
  background: #dbeafe;

  cursor: pointer;
}
.location-cell,
.period-cell {
  display: flex;
  align-items: center;
  gap: 7px;

  color: #536174;
  font-size: 12px;
}

.location-cell .anticon,
.period-cell .anticon {
  color: #98a4b5;
  font-size: 12px;
}
.asset-actions {
  display: flex;
  align-items: center;
}
.action-items-payment-accept-btn {
  background: #16a34a12 !important;
  width: 28px !important;
  height: 28px !important;
  opacity: 1;
  border-radius: 10px;
  border-width: 1px;
  border: 1px solid #16a34a40 !important;
  border-color: #9de1b9;
  color: #36a765 !important;
}
.action-items-payment-chat-btn {
  width: 28px !important;
  height: 28px !important;
  opacity: 1;
  border-radius: 10px;
  border-width: 1px;
  background: #d9770612 !important;
  border: 1px solid #d9770640 !important;
  border-color: #ffd29a !important;
  color: #f49a22 !important;
  background: #fffaf2 !important;
}

.action-items-payment-accept-btn:hover {
  border-color: #36a765 !important;
  color: #36a765 !important;
}

.action-items-payment-chat-btn:hover {
  border-color: #f49a22 !important;
  color: #f49a22 !important;
}
.action-items-payment-move-btn {
  width: 28px !important;
  height: 28px !important;
  opacity: 1;
  border-radius: 10px;
  border-width: 1px;
  border: 1px solid #6366f140;
  border-color: #bfc9ff !important;
  color: #6678e8 !important;
  background: #f7f8ff !important;
}

.action-items-payment-move-btn:hover {
  border-color: #6678e8 !important;
  color: #6678e8 !important;
}

.action-items-payment-reject-btn {
  width: 28px !important;
  height: 28px !important;
  opacity: 1;
  border-radius: 10px;
  border-width: 1px;
  background: #d2042d12 !important;
  border: 1px solid #d2042d40 !important;
  color: #e53b58 !important;
}

.action-items-payment-reject-btn:hover {
  border-color: #e53b58 !important;
  color: #e53b58 !important;
}
.asset-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-width: 160px;
  white-space: nowrap;
}
.negotiate-summary {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 72px;
  padding: 12px 20px;
  border: 1px solid #edf0f4;
  border-radius: 16px;
  background: #fff;
}

.summary-left {
  display: flex;
  align-items: center;
  gap: 22px;
}

.summary-item strong {
  font-weight: 600;
}

.accepted-value {
  color: #12a15c;
}

.negotiating-value {
  color: #f59e0b;
}

.total-value {
  color: #e0002b;
  font-size: 17px !important;
}

.summary-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.review-warning {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #e17100 !important;
  font-size: 12px;
}
.terms-app-chat-red-container {
  height: 72px;
  background: #d2042d;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 21px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  flex-shrink: 0;
  padding: 20px;
}
.minimise-chat-icon {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    background-color 0.25s ease,
    box-shadow 0.25s ease;
}
.minimise-chat-icon:hover {
  background-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.08);
}
.chat-date-price-conatiner {
  width: 100% !important;
  height: 33px !important;
  border-bottom-width: 1px;
  background: #f9fafb;
  border-bottom: 1px solid #f3f4f6;
  padding-top: 8px;
  padding-right: 12px;
  padding-bottom: 8px;
  padding-left: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.seller-intial-chat-div {
  padding-top: 8px;
  width: 50%;
  padding-right: 12px;
  padding-bottom: 8px;
  padding-left: 12px;
  border-top-left-radius: 6px;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 16px;
  background: #f3f4f6;
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 5px;
}
.chat-input-container {
  display: flex;
  padding: 0px 15px;
  gap: 5px;
}
.chat-message-input {
  height: 34px !important;
  opacity: 1;
  padding-top: 8px;
  padding-right: 12px;
  padding-bottom: 8px;
  padding-left: 12px;
  border-radius: 14px;
  border-width: 1px;
  border: 1px solid #e5e7eb !important;
}
.asset-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 22px;
  padding: 0 9px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
}

.asset-status-negotiating {
  color: #d97706 !important;
  background: #fef3c7 !important;
}

.asset-status-accepted {
  color: #059669;
  background: #d9fbe9;
}

.asset-status-approved {
  color: #16a34a !important;
  background: #16a34a12 !important;
}

.asset-status-move {
  background: #6366f112 !important;

  color: #6366f1 !important;
}

.asset-status-rejected {
  color: #d2042d !important;
  background: #d2042d12 !important;
}
.signing-progress-container {
  padding: 20px;
  margin-left: 12px;
}

.signing-progress-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.signing-progress-count {
  color: #98a2b3;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.signing-process-status-bar {
  width: 100%;
  height: 8px;
  opacity: 1;
  border-radius: 33554400px;
  background: #f3f4f6;
  margin-bottom: 20px;
}

.signing-process-steps {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #667085;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  white-space: nowrap;
}

.signing-step {
  display: flex;
  align-items: center;
  gap: 6px;
}

.signing-step-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  border: 2px solid #d0d5dd;
  border-radius: 50%;
  background: #ffffff;
  box-sizing: border-box;
}

.signing-step-arrow {
  color: #d0d5dd;
  font-size: 22px;
  line-height: 16px;
  margin: 0 2px;
}

.io-document-card {
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.io-document-left {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.io-document-icon {
  width: 32px;
  height: 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;
  flex-shrink: 0;
}

.buyer-icon {
  color: #e11d48;
  background: #fff1f2;
}

.company-icon {
  color: #e11d48;
  background: #fff1f2;
}

.io-document-content {
  display: flex;
  flex-direction: column;
}

.io-document-tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;

  margin-top: 7px;
}

.io-document-tags span {
  padding: 3px 9px;

  color: #667085;
  background: #f8fafc;

  border: 1px solid #f2f4f7;
  border-radius: 6px;

  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
}
.io-document-right {
  min-width: 220px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  align-self: stretch;
}

.io-status {
  padding: 4px 10px;

  border-radius: 999px;

  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
}

.io-status.awaiting {
  color: #e11d48;
  background: #fff1f2;
}

.io-status.pending {
  color: #d97706;
  background: #fff7d6;
}

.io-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.io-download-btn {
  height: 30px !important;
  gap: 6px;
  border-radius: 14px;
  border-width: 1px;
  border: 1px solid #e5e7eb !important;
}

.io-sign-btn {
  height: 30px;
  display: flex;
  align-items: center;
  gap: 6px;
  background: #d8003f !important;
  border: none;
  border-radius: 14px;
}

.sign-later {
  color: #98a2b3;
  font-size: 10px;
  font-style: italic;
  white-space: nowrap;
}

.back-review-btn {
  height: 32px;
  margin-top: 4px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 7px;
  background: #ffffff;
  border: 1px solid #e4e7ec !important;
  border-radius: 10px;
}
.campaign-selection-dropdown {
  width: 360px;
  max-height: 420px;
  overflow-y: auto;

  padding: 6px;

  background: #ffffff;
  border: 1px solid #eaecf0;
  border-radius: 10px;

  box-shadow: 0px 4px 12px rgba(16, 24, 40, 0.12);
}

.campaign-dropdown-item {
  padding: 10px 12px;

  border-radius: 8px;

  cursor: pointer;
}

.campaign-dropdown-item:hover {
  background: #f9fafb;
}

.campaign-dropdown-item.selected-campaign {
  background: #fff7f8;
}

.campaign-dropdown-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.campaign-dropdown-name {
  display: block;

  color: #101828;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.campaign-dropdown-meta {
  margin-top: 2px;

  color: #667085;
  font-size: 11px;
  line-height: 16px;
}

.campaign-selected-icon {
  color: #d2042d;
  font-size: 14px;
  margin-top: 3px;
}

.campaign-dropdown-products {
  margin-top: 8px;
  margin-left: 4px;
  padding-left: 12px;

  border-left: 1px solid #eaecf0;
}

.campaign-dropdown-product {
  display: flex;
  align-items: center;

  gap: 7px;

  padding: 5px 0;
}

.campaign-product-dot {
  width: 5px;
  height: 5px;
  flex-shrink: 0;

  background: #98a2b3;
  border-radius: 50%;
}

.campaign-product-name {
  color: #667085;
  font-size: 11px;
  line-height: 16px;
}

.campaign-dropdown-empty {
  padding: 20px;

  text-align: center;

  color: #98a2b3;
  font-size: 12px;
}

.campaign-dropdown-arrow-open {
  transform: rotate(180deg);
}
.sticky-header-section {
  margin-left: 12px;
}
.common-button-green {
  background: #ecfdf3;
  border: 1px solid #ecfdf3;
  color: #008236 !important;
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Medium !important;
  font-size: 14px !important;
  line-height: 19.5px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
}

.review-products-count-completed {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #bbf7d0;
  color: #008236;
  border-radius: 50%;
  font-size: 12px;
}
.all-negotiation-button {
  border: 2px solid var(--Colors-Primary-500, #d2042d) !important;
  color: #d2042d !important;
}
@media (max-width: 768px) {
  .re-design-campaign-selection-row {
    padding: 20px !important;
  }
  .messages-page-header {
    flex-direction: column;
  }
  .messages-header-actions {
    width: 100%;
    justify-content: space-between;
  }
  .messages-main-card {
    width: 100% !important;
    height: auto !important;
    margin: 0 auto;
    padding: 0 !important;
    display: flex;
    overflow: hidden;
    margin-top: 15px;
  }
  .messages-conversation-list-width {
    width: 30% !important;
  }
  .middle-chat-container-width {
    width: 67% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/BuyerFlow/payments-pages/NegotiationTerms.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,gDAAgD;EAChD,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAS;EACT,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gDAAgD;EAChD,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,kBAAkB;;EAElB,gBAAgB;EAChB,2CAA2C;;EAE3C,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;;EAEnB,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;EACtC,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,cAAc;EACd,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;;yBAEuB;AACzB;AACA;EACE,2CAA2C;EAC3C,+CAA+C;AACjD;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;AACtC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;;EAEhC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;;EAER,eAAe;AACjB;;AAEA;EACE,gBAAgB;;EAEhB,cAAc;EACd,mBAAmB;;EAEnB,yBAAyB;EACzB,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;;EAEjB,oBAAoB;;EAEpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;;EAEhB,YAAY;;EAEZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;;EAEnB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;;EAElB,kBAAkB;;EAElB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;;EAEd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;;EAEf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;EAElB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,QAAQ;;EAER,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;;EAEd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;;EAEb,kBAAkB;;EAElB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,+DAA+D;EAC/D,yBAAyB;AAC3B;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,8BAA8B;EAChC;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".re-design-campaign-selection-row {\n  padding: 20px 73px 20px 55px !important;\n  background: var(--Icon-Default-Default, #ffffff);\n  border-bottom: 1px solid #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.re-design-campaign-selection-col {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.review-products-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.2);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n}\n.review-products-count-grey {\n  background: #e5e7eb;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  color: #99a1af;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n}\n.review-each-asset-conatiner {\n  display: flex;\n  align-items: center;\n  gap: 5px !important;\n  width: 100% !important;\n  border-radius: 16px;\n  border-width: 1px;\n  border-top: 1px solid #f3f4f6;\n  height: 60px;\n  border: 1px solid #edf0f4;\n  border-radius: 16px;\n  background: #fff !important;\n  padding: 20px;\n}\n.negotiate-terms-container {\n  width: 93%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n}\n.negotiate-terms-chat-container {\n  width: 5%;\n  height: 100%;\n  opacity: 1;\n  border-radius: 16px;\n  border-width: 1px;\n  background: var(--Icon-Default-Default, #ffffff);\n  border: 1px solid #f3f4f6;\n}\n.negotiate-terms-table-container {\n  width: 70%;\n}\n.negotiate-terms-chat {\n  width: 25%;\n}\n.assets-table-wrapper {\n  width: 100%;\n  overflow: hidden;\n  border: 1px solid #edf0f4;\n  border-radius: 16px;\n  background: #fff;\n}\n\n.negotiate-assets-table {\n  width: 100%;\n}\n\n.negotiate-assets-table .ant-table {\n  background: transparent;\n}\n\n.negotiate-assets-table .ant-table-container {\n  border: none !important;\n}\n\n.negotiate-assets-table .ant-table-thead > tr > th {\n  height: 38px;\n  padding: 0 20px;\n  border-bottom-width: 1px;\n  background: #f9fafb !important;\n  border-bottom: 1px solid #f3f4f6;\n  color: #99a1af !important;\n  font-family: Roboto !important;\n  font-weight: 600;\n  font-style: Semi Bold;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n}\n\n.negotiate-assets-table .ant-table-thead > tr > th::before {\n  display: none !important;\n}\n\n.negotiate-assets-table .ant-table-tbody > tr > td {\n  height: 60px;\n  padding: 10px 20px;\n\n  background: #fff;\n  border-bottom: 1px solid #f0f2f5 !important;\n\n  color: #526174;\n  font-size: 12px;\n}\n\n.negotiate-assets-table .ant-table-tbody > tr:last-child > td {\n  border-bottom: none !important;\n}\n\n.negotiate-assets-table .ant-table-tbody > tr:hover > td {\n  background: #fff !important;\n}\n.asset-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.asset-meta {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n\n  color: #9aa5b5;\n  font-size: 10px;\n}\n\n.slot-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 17px;\n  height: 17px;\n  padding: 0;\n  border: 1px solid #d9e0ea;\n  border-radius: 4px;\n  background: #dbeafe;\n\n  cursor: pointer;\n}\n.location-cell,\n.period-cell {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n\n  color: #536174;\n  font-size: 12px;\n}\n\n.location-cell .anticon,\n.period-cell .anticon {\n  color: #98a4b5;\n  font-size: 12px;\n}\n.asset-actions {\n  display: flex;\n  align-items: center;\n}\n.action-items-payment-accept-btn {\n  background: #16a34a12 !important;\n  width: 28px !important;\n  height: 28px !important;\n  opacity: 1;\n  border-radius: 10px;\n  border-width: 1px;\n  border: 1px solid #16a34a40 !important;\n  border-color: #9de1b9;\n  color: #36a765 !important;\n}\n.action-items-payment-chat-btn {\n  width: 28px !important;\n  height: 28px !important;\n  opacity: 1;\n  border-radius: 10px;\n  border-width: 1px;\n  background: #d9770612 !important;\n  border: 1px solid #d9770640 !important;\n  border-color: #ffd29a !important;\n  color: #f49a22 !important;\n  background: #fffaf2 !important;\n}\n\n.action-items-payment-accept-btn:hover {\n  border-color: #36a765 !important;\n  color: #36a765 !important;\n}\n\n.action-items-payment-chat-btn:hover {\n  border-color: #f49a22 !important;\n  color: #f49a22 !important;\n}\n.action-items-payment-move-btn {\n  width: 28px !important;\n  height: 28px !important;\n  opacity: 1;\n  border-radius: 10px;\n  border-width: 1px;\n  border: 1px solid #6366f140;\n  border-color: #bfc9ff !important;\n  color: #6678e8 !important;\n  background: #f7f8ff !important;\n}\n\n.action-items-payment-move-btn:hover {\n  border-color: #6678e8 !important;\n  color: #6678e8 !important;\n}\n\n.action-items-payment-reject-btn {\n  width: 28px !important;\n  height: 28px !important;\n  opacity: 1;\n  border-radius: 10px;\n  border-width: 1px;\n  background: #d2042d12 !important;\n  border: 1px solid #d2042d40 !important;\n  color: #e53b58 !important;\n}\n\n.action-items-payment-reject-btn:hover {\n  border-color: #e53b58 !important;\n  color: #e53b58 !important;\n}\n.asset-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  min-width: 160px;\n  white-space: nowrap;\n}\n.negotiate-summary {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 72px;\n  padding: 12px 20px;\n  border: 1px solid #edf0f4;\n  border-radius: 16px;\n  background: #fff;\n}\n\n.summary-left {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n}\n\n.summary-item strong {\n  font-weight: 600;\n}\n\n.accepted-value {\n  color: #12a15c;\n}\n\n.negotiating-value {\n  color: #f59e0b;\n}\n\n.total-value {\n  color: #e0002b;\n  font-size: 17px !important;\n}\n\n.summary-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.review-warning {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: #e17100 !important;\n  font-size: 12px;\n}\n.terms-app-chat-red-container {\n  height: 72px;\n  background: #d2042d;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-right: 21px;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  flex-shrink: 0;\n  padding: 20px;\n}\n.minimise-chat-icon {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition:\n    background-color 0.25s ease,\n    box-shadow 0.25s ease;\n}\n.minimise-chat-icon:hover {\n  background-color: rgba(255, 255, 255, 0.15);\n  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.08);\n}\n.chat-date-price-conatiner {\n  width: 100% !important;\n  height: 33px !important;\n  border-bottom-width: 1px;\n  background: #f9fafb;\n  border-bottom: 1px solid #f3f4f6;\n  padding-top: 8px;\n  padding-right: 12px;\n  padding-bottom: 8px;\n  padding-left: 12px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.seller-intial-chat-div {\n  padding-top: 8px;\n  width: 50%;\n  padding-right: 12px;\n  padding-bottom: 8px;\n  padding-left: 12px;\n  border-top-left-radius: 6px;\n  border-top-right-radius: 16px;\n  border-bottom-right-radius: 16px;\n  border-bottom-left-radius: 16px;\n  background: #f3f4f6;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-top: 5px;\n}\n.chat-input-container {\n  display: flex;\n  padding: 0px 15px;\n  gap: 5px;\n}\n.chat-message-input {\n  height: 34px !important;\n  opacity: 1;\n  padding-top: 8px;\n  padding-right: 12px;\n  padding-bottom: 8px;\n  padding-left: 12px;\n  border-radius: 14px;\n  border-width: 1px;\n  border: 1px solid #e5e7eb !important;\n}\n.asset-status {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 22px;\n  padding: 0 9px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.asset-status-negotiating {\n  color: #d97706 !important;\n  background: #fef3c7 !important;\n}\n\n.asset-status-accepted {\n  color: #059669;\n  background: #d9fbe9;\n}\n\n.asset-status-approved {\n  color: #16a34a !important;\n  background: #16a34a12 !important;\n}\n\n.asset-status-move {\n  background: #6366f112 !important;\n\n  color: #6366f1 !important;\n}\n\n.asset-status-rejected {\n  color: #d2042d !important;\n  background: #d2042d12 !important;\n}\n.signing-progress-container {\n  padding: 20px;\n  margin-left: 12px;\n}\n\n.signing-progress-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.signing-progress-count {\n  color: #98a2b3;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.signing-process-status-bar {\n  width: 100%;\n  height: 8px;\n  opacity: 1;\n  border-radius: 33554400px;\n  background: #f3f4f6;\n  margin-bottom: 20px;\n}\n\n.signing-process-steps {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #667085;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  white-space: nowrap;\n}\n\n.signing-step {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.signing-step-circle {\n  width: 14px;\n  height: 14px;\n  min-width: 14px;\n  border: 2px solid #d0d5dd;\n  border-radius: 50%;\n  background: #ffffff;\n  box-sizing: border-box;\n}\n\n.signing-step-arrow {\n  color: #d0d5dd;\n  font-size: 22px;\n  line-height: 16px;\n  margin: 0 2px;\n}\n\n.io-document-card {\n  width: 100%;\n  padding: 12px 16px;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.io-document-left {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.io-document-icon {\n  width: 32px;\n  height: 34px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 10px;\n  flex-shrink: 0;\n}\n\n.buyer-icon {\n  color: #e11d48;\n  background: #fff1f2;\n}\n\n.company-icon {\n  color: #e11d48;\n  background: #fff1f2;\n}\n\n.io-document-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.io-document-tags {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n\n  margin-top: 7px;\n}\n\n.io-document-tags span {\n  padding: 3px 9px;\n\n  color: #667085;\n  background: #f8fafc;\n\n  border: 1px solid #f2f4f7;\n  border-radius: 6px;\n\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 14px;\n}\n.io-document-right {\n  min-width: 220px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: flex-end;\n  align-self: stretch;\n}\n\n.io-status {\n  padding: 4px 10px;\n\n  border-radius: 999px;\n\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 14px;\n}\n\n.io-status.awaiting {\n  color: #e11d48;\n  background: #fff1f2;\n}\n\n.io-status.pending {\n  color: #d97706;\n  background: #fff7d6;\n}\n\n.io-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.io-download-btn {\n  height: 30px !important;\n  gap: 6px;\n  border-radius: 14px;\n  border-width: 1px;\n  border: 1px solid #e5e7eb !important;\n}\n\n.io-sign-btn {\n  height: 30px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #d8003f !important;\n  border: none;\n  border-radius: 14px;\n}\n\n.sign-later {\n  color: #98a2b3;\n  font-size: 10px;\n  font-style: italic;\n  white-space: nowrap;\n}\n\n.back-review-btn {\n  height: 32px;\n  margin-top: 4px;\n  padding: 0 14px;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  background: #ffffff;\n  border: 1px solid #e4e7ec !important;\n  border-radius: 10px;\n}\n.campaign-selection-dropdown {\n  width: 360px;\n  max-height: 420px;\n  overflow-y: auto;\n\n  padding: 6px;\n\n  background: #ffffff;\n  border: 1px solid #eaecf0;\n  border-radius: 10px;\n\n  box-shadow: 0px 4px 12px rgba(16, 24, 40, 0.12);\n}\n\n.campaign-dropdown-item {\n  padding: 10px 12px;\n\n  border-radius: 8px;\n\n  cursor: pointer;\n}\n\n.campaign-dropdown-item:hover {\n  background: #f9fafb;\n}\n\n.campaign-dropdown-item.selected-campaign {\n  background: #fff7f8;\n}\n\n.campaign-dropdown-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.campaign-dropdown-name {\n  display: block;\n\n  color: #101828;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.campaign-dropdown-meta {\n  margin-top: 2px;\n\n  color: #667085;\n  font-size: 11px;\n  line-height: 16px;\n}\n\n.campaign-selected-icon {\n  color: #d2042d;\n  font-size: 14px;\n  margin-top: 3px;\n}\n\n.campaign-dropdown-products {\n  margin-top: 8px;\n  margin-left: 4px;\n  padding-left: 12px;\n\n  border-left: 1px solid #eaecf0;\n}\n\n.campaign-dropdown-product {\n  display: flex;\n  align-items: center;\n\n  gap: 7px;\n\n  padding: 5px 0;\n}\n\n.campaign-product-dot {\n  width: 5px;\n  height: 5px;\n  flex-shrink: 0;\n\n  background: #98a2b3;\n  border-radius: 50%;\n}\n\n.campaign-product-name {\n  color: #667085;\n  font-size: 11px;\n  line-height: 16px;\n}\n\n.campaign-dropdown-empty {\n  padding: 20px;\n\n  text-align: center;\n\n  color: #98a2b3;\n  font-size: 12px;\n}\n\n.campaign-dropdown-arrow-open {\n  transform: rotate(180deg);\n}\n.sticky-header-section {\n  margin-left: 12px;\n}\n.common-button-green {\n  background: #ecfdf3;\n  border: 1px solid #ecfdf3;\n  color: #008236 !important;\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Medium !important;\n  font-size: 14px !important;\n  line-height: 19.5px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n}\n\n.review-products-count-completed {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #bbf7d0;\n  color: #008236;\n  border-radius: 50%;\n  font-size: 12px;\n}\n.all-negotiation-button {\n  border: 2px solid var(--Colors-Primary-500, #d2042d) !important;\n  color: #d2042d !important;\n}\n@media (max-width: 768px) {\n  .re-design-campaign-selection-row {\n    padding: 20px !important;\n  }\n  .messages-page-header {\n    flex-direction: column;\n  }\n  .messages-header-actions {\n    width: 100%;\n    justify-content: space-between;\n  }\n  .messages-main-card {\n    width: 100% !important;\n    height: auto !important;\n    margin: 0 auto;\n    padding: 0 !important;\n    display: flex;\n    overflow: hidden;\n    margin-top: 15px;\n  }\n  .messages-conversation-list-width {\n    width: 30% !important;\n  }\n  .middle-chat-container-width {\n    width: 67% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
